import { registerPageInit } from '../barba/page-init-registry';
import '../../css/pages/about/about-documents.scss';
import { DocumentsSearchWidget } from '../widgets/documents-search-widget';

class AboutDocuments {
  private documentsSearchWidget: DocumentsSearchWidget;

  constructor() {
    this.documentsSearchWidget = new DocumentsSearchWidget();
  }

  public init(): void {
    this.documentsSearchWidget.init();
  }
}

registerPageInit('about-documents', () => {
  const page = new AboutDocuments();
  page.init();
});
